<div 
    class="viz-container" 
    [ngClass]="orientation === 'Horizontal' ? 'horizontal-bar': ''"
    #viz
>
    <div class="controls"></div>
    <figure [id]="dynamicSvgContainerId"></figure>
</div>
